






import { Component, Vue } from "vue-property-decorator";
import { UserModule } from './store/modules/user';

@Component({
  [`name`]:'app'
})
export default class extends Vue {
  mounted() {
    this.beforeunload();
  }

  private beforeunload() {
    window.addEventListener("beforeunload", e => {
      // this.$store.commit("SET_LOAD_MENUS",true)
      UserModule.updateLoadMenu4Refresh()
    });
  }
}
